module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thin_heart.6bada47a.png";